export default ['', 'compact', 'compactSide', 'uniformSide', 'uniformFull'];